import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { Knowbe4Service } from '../../service';

export type TrainingCampaignUserEnrollmentConfig =
  typeof TrainingCampaignUserEnrollmentConfig._.Config;

export const TrainingCampaignUserEnrollmentConfig = IntegrationConfig.make({
  service: Knowbe4Service,
  name: Integration_Handler_Names_Enum.TrainingCampaignUserEnrollment,
  configSchema: z.object({
    campaignId: z.number(),
    maximumPastDuePercentage: z.number().min(0).max(100).optional(),
  }),
});
